import type { ReadSearchApiArg } from 'lib-search-types';
import { filterFieldCatalogue, filterOperatorCatalogue } from 'lib-search-ui';
import { memo, useMemo } from 'react';

import { SearchScopeFilter } from 'components/search';

import { useSearchQuickFilter } from '../../utils/useSearchQuickFilter';

export const SearchAgentQuickFilter = memo(
  function SearchAgentQuickFilter(): JSX.Element {
    const { condition, handleChange } = useSearchQuickFilter('agent_id');

    const initialArg: ReadSearchApiArg<'users'> = useMemo(
      () => ({
        scope: 'users',
        sortBy: { field: 'display_name', order: 'asc' },
        filters: {
          strategy: 'all',
          filters: [
            {
              field: 'user_type',
              operator: 'is_one',
              values: [{ value: 'member' }],
            },
          ],
        },
      }),
      [],
    );

    return (
      <SearchScopeFilter
        scope="users"
        placeholder="Search agents..."
        operators={filterOperatorCatalogue.conversations.agent_id.operators}
        defaultOperator={
          filterOperatorCatalogue.conversations.agent_id.defaultOperator
        }
        selectedValues={condition?.values}
        selectedOperator={condition?.operator}
        initialArg={initialArg}
        onChange={handleChange}
      >
        {filterFieldCatalogue.conversations.agent_id.label}
      </SearchScopeFilter>
    );
  },
);
